import React from 'react';

import BaseOnOff from '@adsk/bim360-matrix-react-base-on-off';

import './_Toggle.scss';

/**
 * A toggle button for indicating on/off status
 */
export default class Toggle extends BaseOnOff {
  /**
   * constructor
   * @param props
   */
  constructor(props) {
    super(props);
  }

  /**
   * renderInnerComponent
   */
  renderInnerComponent() {
    return (
      <div>
        <div className="Toggle__track" />
        <div className="Toggle__thumb" />
      </div>
    );
  }

  /**
   * render
   */
  render() {
    return super.render('Toggle', this.renderInnerComponent);
  }
}

Toggle.propTypes = {
  ...BaseOnOff.propTypes
};
